<script setup lang="ts">
// TODO - get these loading in from directus
import { Dialog } from "@headlessui/vue";
import type { BranchImages } from "~/types/directus-collections.d.ts";

const props = defineProps<{
  images: BranchImages[];
}>();

const route = useRoute();
const router = useRouter();
const carousel = ref<HTMLElement>();

const carouselPrevEnabled = computed(() => carouselIndex.value !== undefined && carouselIndex.value > 0);
const carouselNextEnabled = computed(() => carouselIndex.value !== undefined && carouselIndex.value < props.images.length - 1);

const carouselIndex = computed({
  get: () => (typeof route.query.gallery === "string" ? parseInt(route.query.gallery, 10) : undefined),
  set: (v) => {
    router.replace({ query: { ...route.query, gallery: v } });
  },
});

function scrollindex() {
  if (!carousel.value || carouselIndex.value === undefined) {
    return;
  }

  carousel.value.scrollTo({
    left: carousel.value.offsetWidth * carouselIndex.value,
    top: 0,
    behavior: "smooth",
  });
}

onMounted(() => {
  nextTick(() => {
    scrollindex();
  });
});

watch(carouselIndex, () => {
  nextTick(() => {
    scrollindex();
  });
});
const isOpen = computed(() => carouselIndex.value !== undefined);

function setIsOpen(value: boolean, index?: number) {
  carouselIndex.value = value ? index : undefined;
}

function scrollNext() {
  if (!carousel.value || carouselIndex.value === undefined) return;
  carouselIndex.value = carouselIndex.value + 1;
}
function scrollPrev() {
  if (!carousel.value || carouselIndex.value === undefined) return;
  carouselIndex.value = carouselIndex.value - 1;
}
</script>

<template>
  <div>
    <div class="grid grid-flow-dense auto-rows-auto grid-cols-1 gap-8 md:grid-cols-2 xl:grid-cols-3">
      <CommonGalleryImage v-for="(image, index) in images" :key="index" :image="image" @click="setIsOpen(true, index)" />
    </div>
    <Dialog :open="isOpen" class="relative z-50" @close="setIsOpen">
      <div class="fixed inset-0 bg-black/70" aria-hidden="true"></div>
      <div class="fixed inset-0 flex w-screen items-center justify-center">
        <div ref="carousel" class="scrollbar-hide relative flex snap-x snap-mandatory flex-row overflow-x-auto overflow-y-hidden">
          <div v-for="(image, index) in images" :key="index" class="h-screen w-screen shrink-0 grow-0 snap-center p-[10%]">
            <CommonDirectusImage class="size-full object-contain" :img="image?.image"> </CommonDirectusImage>
          </div>
        </div>
        <button
          class="group absolute bottom-1/2 left-10 hidden translate-y-1/2 text-3xl text-white md:block"
          :disabled="!carouselPrevEnabled"
          @click="scrollPrev"
        >
          <font-awesome-icon icon="fa-solid fa-angle-left" size="2xl" class="group-disabled:opacity-35" />
        </button>
        <button
          class="group absolute bottom-1/2 right-10 hidden translate-y-1/2 text-3xl text-white md:block"
          :disabled="!carouselNextEnabled"
          @click="scrollNext"
        >
          <font-awesome-icon icon="fa-solid fa-angle-right" size="2xl" class="group-disabled:opacity-35" />
        </button>
        <button class="group absolute right-20 top-10 text-3xl text-white" @click="setIsOpen(false)">
          <font-awesome-icon icon="fa-solid fa-close" size="2xl" class="group-disabled:opacity-35" />
        </button>
      </div>
    </Dialog>
  </div>
</template>

<style lang="postcss">
/* For Webkit-based browsers (Chrome, Safari and Opera) */
.scrollbar-hide::-webkit-scrollbar {
  display: none;
}

/* For IE, Edge and Firefox */
.scrollbar-hide {
  -ms-overflow-style: none;
  /* IE and Edge */
  scrollbar-width: none;
  /* Firefox */
}
</style>
